import { uphsCarelonDirectoryConfiguration } from './uphs'
import { CustomerName } from '../../common/constants/customer'

import type { CarelonDirectoryCustomerConfiguration, CarelonDirectoryCustomerConfigurations } from '../types'

export const carelonDirectoryCustomerConfigurations: CarelonDirectoryCustomerConfigurations = {
  [CustomerName.UPHS]: uphsCarelonDirectoryConfiguration,
}

const isConfiguredCustomer = (
  customerName: string,
  configurations: CarelonDirectoryCustomerConfigurations,
): customerName is CustomerName => Object.prototype.hasOwnProperty.call(configurations, customerName)

export const getCarelonDirectoryCustomerConfiguration = (
  customerName: string | undefined,
  configurations: CarelonDirectoryCustomerConfigurations = carelonDirectoryCustomerConfigurations,
): CarelonDirectoryCustomerConfiguration | undefined => {
  if (!customerName || !isConfiguredCustomer(customerName, configurations)) {
    return undefined
  }

  return configurations[customerName]
}
